const state = {
  unreadNo: 0,
  is_turnring: 0,
  btnPer: {}
}

const mutations = {
  change_UnRead_No: (state, unreadNo) => {
    state.unreadNo = unreadNo
  },
  get_Ring: (state, is_turnring) => {
    state.is_turnring = is_turnring
  },
  set_btnPer: (state, btnPer) => {
    state.btnPer = btnPer
  }
}

const actions = {
  changeUnReadNo({ commit }, unreadNo) {
    commit('change_UnRead_No', unreadNo)
  },
  getRing({ commit }, is_turnring) {
    commit('get_Ring', is_turnring)
  },
  setBtnPer({ commit }, btnPer) {
    commit('set_btnPer', btnPer)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
